import { render, staticRenderFns } from "./admis2.vue?vue&type=template&id=2e53d47a"
import script from "./admis2.vue?vue&type=script&lang=js"
export * from "./admis2.vue?vue&type=script&lang=js"
import style0 from "./admis2.vue?vue&type=style&index=0&id=2e53d47a&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderContactPage: require('/home/apprentissage-montpellier/www/prod/AM-frontend/components/HeaderContactPage.vue').default,ErrorFieldHandler: require('/home/apprentissage-montpellier/www/prod/AM-frontend/components/ErrorFieldHandler.vue').default,FormErrorPopUp: require('/home/apprentissage-montpellier/www/prod/AM-frontend/components/FormErrorPopUp.vue').default})
